export default __webpack_public_path__ + "static/logo9-244963dc7b18070d7438829d3c25bc27.webp";